import React from "react";
import { Box, Container, Typography, Button, useMediaQuery } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Image from "../Images/UlapRecPictures/1.jpg";
import ImageOne from "../Images/UlapRecPictures/2.png";
import ImageTwo from "../Images/UlapRecPictures/3.png";
import InfoIcon from "@material-ui/icons/Info";

const useStyles = makeStyles((theme) => ({
    heroContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        paddingTop: theme.spacing(12.5),
        paddingBottom: theme.spacing(12.5),
        flexDirection: "row",
        [theme.breakpoints.down("md")]: { 
            flexDirection: "column",
            paddingTop: theme.spacing(7.5),
            paddingBottom: theme.spacing(7.5),
        },
        [theme.breakpoints.down("sm")]: { 
            flexDirection: "column-reverse", 
            paddingTop: theme.spacing(5),
            paddingBottom: theme.spacing(6.25),
        },
    },
    heroContainerTwo: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        paddingTop: theme.spacing(12.5),
        paddingBottom: theme.spacing(12.5),
        flexDirection: "row",
        [theme.breakpoints.down("md")]: { 
            flexDirection: "column",
            paddingTop: theme.spacing(7.5),
            paddingBottom: theme.spacing(7.5),
        },
        [theme.breakpoints.down("sm")]: { 
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(6.25),
        },
    },
    textContainer: {
        flex: 1,
        marginRight: theme.spacing(2.5),
        [theme.breakpoints.down("md")]: { 
            marginRight: theme.spacing(1.25), 
            marginBottom: theme.spacing(2.5),
            textAlign: "left", 
        },
        [theme.breakpoints.down("sm")]: { 
            marginRight: 0,
            marginBottom: theme.spacing(2),
            textAlign: "left",
        },
    },
    title: {
        fontSize: "40px",
        fontWeight: "bold",
        color: "#FF7707",
        lineHeight: 1.3, 
        marginBottom: theme.spacing(1.25),
        [theme.breakpoints.down("md")]: { 
            paddingTop: theme.spacing(2.5),
            fontSize: "40px",
        },
        [theme.breakpoints.down("sm")]: {
            paddingTop: theme.spacing(2.5),
            fontSize: "30px",
        },
    },
    image: {
        flex: 1,
        maxWidth: "40%",
        height: "auto",
        marginRight: "40px",
        [theme.breakpoints.down("md")]: { 
            maxWidth: "80%", 
            margin: "0 auto", 
        },
        [theme.breakpoints.down("sm")]: {
            maxWidth: "100%",
            margin: "0 auto", 
        },
    },
    description: {
        fontSize: "18px",
        marginBottom: theme.spacing(2),
        [theme.breakpoints.down("md")]: { 
            fontSize: "17px",
        },
        [theme.breakpoints.down("sm")]: { 
            textAlign: "justify",
            fontSize: "16px",
        },
    },
    descriptionWithIcon: {
        display: "flex",
        alignItems: "flex-start",
        marginBottom: theme.spacing(1),
        fontSize: "20px",
        [theme.breakpoints.down("md")]: { 
            fontSize: "17px",
        },
        [theme.breakpoints.down("sm")]: { 
            textAlign: "justify",
            fontSize: "16px",
        },
    },
    icon: {
        marginRight: theme.spacing(1),
        marginTop: theme.spacing(0.5),
    },
    button: {
        color: theme.palette.primary.contrastText,
        border: `1px solid ${theme.palette.primary.contrastText}`,
        marginTop: theme.spacing(2.5),
        padding: theme.spacing(1.25, 2.5),
        textTransform: "none",
        borderRadius: theme.shape.borderRadius * 5,
        [theme.breakpoints.down("md")]: {
            width: "50%",
        },
        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },
    },

}));

function ConnectingPage() {
    const classes = useStyles();

    return (
        <>
         <Container className={classes.heroContainer}>
                <img src={ImageTwo} alt="Image" className={classes.image} />
                <Box className={classes.textContainer}>
                    <Typography className={classes.title}>Still Struggling to Find 
                    the Qualified Candidates?</Typography>

                    <Typography className={classes.description}>
                    Yeah, we get it—you’re thinking about the expensive recruitment agencies.
                    </Typography>

                    <Typography className={classes.description}>
                    Let’s be for real, working with an recruitment agency can feel like handling over a stack of cash and praying for a miracle. 
                    </Typography>

                    <Typography className={classes.description}>
                    A typical agency fee can range from 15% to 30% of the hire’s first-year salary and there’s no guarantee you’ll even find the right candidate. 
                    </Typography>
                </Box>
            </Container>


            <Container className={classes.heroContainerTwo}>
                <Box className={classes.textContainer}>
                    <Typography className={classes.title}>Skipping Recruiters Hurts More</Typography>
                    <Typography className={classes.description}>
                        A broken hiring process isn’t just annoying—it’s expensive.
                        You thought dodging agency fees was smart budgeting. <br />
                        Then reality hits:
                    </Typography>

                    <Box className={classes.descriptionWithIcon}>
                        <InfoIcon className={classes.icon} />
                        <Typography className={classes.description}>Your team spends 12+ hours/week screening resumes instead of doing their actual jobs.</Typography>
                    </Box>

                    <Box className={classes.descriptionWithIcon}>
                        <InfoIcon className={classes.icon} />
                        <Typography className={classes.description}>New hires arrive to no clear plan, slowing productivity and increasing early turnover.</Typography>
                    </Box>

                    <Box className={classes.descriptionWithIcon}>
                        <InfoIcon className={classes.icon} />
                        <Typography className={classes.description}>That perfect candidate accepted another offer 3 weeks ago.</Typography>
                    </Box>
                </Box>
                <img src={ImageOne} alt="Image" className={classes.image} />
            </Container>

           
        </>
    );
}

export default ConnectingPage;
